// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"0aa6f6c3","671":"74d8c320"}[chunkId] + ".chunk.js";
};